
export const debuglog = (...args: any[]): void => {
    if ((window as any).debug) {
        console.log(...args);    
    }    
};